import { useLocation } from 'react-router-dom'
import HospitalRoomScene from './Scenes/HospitalRoomScene'
import React from 'react'
import HospitalCorridorScene from './Scenes/HospitalCorridorScene'
import HospitalKitchenScene from './Scenes/HospitalKitchenScene'
import { NotFoundPage } from '../pages'
import { useScoreStore } from '../store/ScoreStore'

export default function SceneWrapper () {
  const location = useLocation()
  let pathToCheck = location.pathname
  if (pathToCheck !== window.location.pathname) pathToCheck = window.location.pathname

  // We could maybe do some prefetching of information here from a database etc
  // for now, ensure score is 0
  useScoreStore.getState().setRoomScoreId(pathToCheck.substring(1))

  switch (pathToCheck) {
    case '/room':
      return (<HospitalRoomScene />)
    case '/hall':
      return (<HospitalCorridorScene />)
    case '/kitchen':
      return (<HospitalKitchenScene />)
  }

  return (<NotFoundPage />)
}
